module.exports = __webpack_public_path__ + "static/img/2024.5b2ab0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024.jpg
// module id = 314
// module chunks = 0